import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import ErrorBoundary from "../api/ErrorBoundary";
import SeoLoader from "../components/seo/SeoLoader";
import { Suspense } from "react";
import FinishCard from "../components/thirdsideCard/FinishCard";

const LayoutWithoutFooter = () => {
  return (
    <ErrorBoundary>
      <SeoLoader />
      <Suspense>
        <Navbar />
        <Outlet />
        <FinishCard />
      </Suspense>
    </ErrorBoundary>
  );
};

export default LayoutWithoutFooter;
